<template>
	<v-app>
		<!--  v-if="authenticated" -->
		<!-- <navbar :navToggle.sync="navigationToggle"></navbar> -->
		<!--v-if="authenticated"  -->
		<navigation-drawer v-if="authenticated" :navToggle.sync="navigationToggle"></navigation-drawer>

		<v-main>
			<v-layout fill-height>
				<router-view style="width: 100%" />
			</v-layout>
		</v-main>

		<v-snackbar
			v-model="snackbar.show"
			:timeout="snackbar.timeout"
			bottom
			:color="snackbarColor"
			elevation="24">
			{{ snackbar.text }}
			<span
				class="text-caption"
				v-if="snackbar.details">
				<br />
				{{ snackbar.details }}
			</span>

			<template v-slot:action="{ attrs }">
				<v-btn
					icon
					v-bind="attrs"
					@click="snackbar.show = false">
					<v-icon> mdi-close </v-icon>
				</v-btn>
			</template>
		</v-snackbar>
	</v-app>
</template>

<script>
// import Navbar from '@/components/Navbar.vue';
import NavigationDrawer from '@/components/NavigationDrawer.vue';
import { changeI18nLang } from '@/i18n';
import { STORAGE } from './utils/constants';
import { mapState } from 'vuex';
// import { messaging } from './firebase'
// import { messaging } from './firebase/messaging'
import { requestForToken, messaging } from './firebase';
import { onMessage } from 'firebase/messaging';
// import { messaging } from './firebase'; // تأكد من مسار ملف firebase

const snackbarTypeEnum = {
	error: 1,
	done: 2,
	info: 3,
};

export default {
	name: 'App',

	components: {
		// Navbar,
		NavigationDrawer,
	},

	data() {
		return {
			navigationToggle: true,

			snackbar: {
				show: false,
				text: null,
				type: null,
				timeout: null,
				details: null,
			},

			snackbarTypeEnum
			// messaging
		};
	},

	computed: {
		...mapState({
			authenticated: state => state.auth.authenticated
		}),

		snackbarColor() {
			switch (this.snackbar.type) {
				case this.snackbarTypeEnum.error:
					return 'error white--text';
				case this.snackbarTypeEnum.done:
					return 'success white--text';
				case this.snackbarTypeEnum.info:
					return 'info white--text';
				default:
					return 'info white--text';
			}
		},
	},

	watch: {
		'i18n.locale'(newVal) {
			if (newVal === 'ar') {
				this.$vuetify.rtl = true;
			} else {
				this.$vuetify.rtl = false;
			}
		},
	},

	methods: {
		changeI18nLang,
		// firebase
		async requestToken() {
			const token = await requestForToken();
			if (token) {
				console.log('FCM Token:', token);
				// يمكنك تخزين الـ token في قاعدة البيانات الخاصة بك أو استخدامه كما تحتاج
			}
		},
		async requestPermission() {
			try {
				await Notification.requestPermission();
				if (Notification.permission === 'granted') {
				console.log('Notification permission granted.');
				// this.getToken();
				this.requestToken()
				} else {
				console.log('Unable to get permission to notify.');
				}
			} catch (error) {
				console.error('Error requesting notification permission:', error);
			}
			},
			async getToken() {
			try {
				const token = await this.requestToken();
				console.log('FCM Token:', token);
				// أرسل هذا الرمز إلى الخادم الخاص بك لتخزينه
			} catch (error) {
				console.error('Error getting FCM token:', error);
			}
		},
		setupForegroundMessageHandler() {
			onMessage(messaging, (payload) => {
				console.log('Message received in foreground:', payload)
				this.showNotification(payload.notification)
			})
		},
		showNotification(notification) {
			const notificationOptions = {
				body: notification.body,
				icon: notification.icon || '/img/icons/android-chrome-192x192.png'
			};
			
			if (!('Notification' in window)) {
			console.log('This browser does not support notifications.');
			} else if (Notification.permission === 'granted') {
				// eslint-disable-next-line no-new
				new Notification(notification.title, notificationOptions);
			}
		}
	},

	mounted() {
		this.$store.dispatch('employee/fetchBriefEmployees');
		this.$store.dispatch('section/fetchAllSections');
		this.$store.dispatch('positions/fetchAllPositions');
		this.$store.dispatch('positions/fetchAllWorkPositions');
		this.$store.dispatch('leaveOrPermission/fetchAll');
		this.$store.dispatch('addTaskType/fetchAll')

		this.$eventBus.$on(
			'show-snackbar',
			(text, { error = false, done = false, info = false, timeout = 5000 }, details) => {
				this.snackbar.show = true;
				this.snackbar.text = text;
				this.snackbar.timeout = timeout;
				this.snackbar.details = details;
				if (error) {
					this.snackbar.type = this.snackbarTypeEnum.error;
				}
				if (done) {
					this.snackbar.type = this.snackbarTypeEnum.done;
				}
				if (info) {
					this.snackbar.type = this.snackbarTypeEnum.info;
				}
			},
		);
		this.setupForegroundMessageHandler()
	},

	created() {
		const cash =
			'{"employee":{"attendance":{"work":"0.1.2.4.5.-1.6.7.8.9.10.3.-1.-1.-1.-1.-1.-1"}},"attendance":{"work":"0.1.2.3.5.6.-1.7.8.9.10.11.4.-1.-1.-1.-1.-1.-1"},"employees":{"currently":"0.1.2.3.4.-1.-1.5.6","temporaries":"0.1.2.3.4.-1.-1.5.6","all":"0.1.2.3.4.5.6","applicants":"0.1.2.3.4.-1.-1","former":"0.1.2.3.-1.-1.4"}}';

		if (!localStorage.getItem(STORAGE.CASH)) localStorage.setItem(STORAGE.CASH, cash);
		// firebase
		this.requestPermission();
	},

	metaInfo() {
		return {
			title: this.$T(`routes.${this.$route.meta.i18nTranslateKey}`),
			titleTemplate: '%s | Beehive'
		}
	}
};
</script>

<style lang="scss">
@import './scss/main.scss';
@import '@beetronix/bee-components/lib/css/index.css';

* {
	&::-webkit-scrollbar {
		height: 5px;
		width: 10px;
		background-color: #f8f8f8;
	}
	&::-webkit-scrollbar-thumb {
		background-color: #274c78aa;
		border-radius: 10px;
	}
}

#app {
	.v-data-table {
		border-radius: $border-radius-root;
	}
	.v-btn:not(.v-btn--fab, .v-btn--icon, .v-btn--rounded) {
		// border-radius: $border-radius-root;
	}

	.bee-handy-smart-table__input-cell *.mb-4 {
		margin-bottom: 6px !important;
	}
	.bee-handy-smart-table {
		.dense-inputs .bee-handy-smart-table__input-cell {
			padding: 0 8px;
		}
	}
}

input:read-only {
	cursor: default;
}

.v-data-table .v-data-table__wrapper .ltr {
	direction: ltr;
	text-align: end !important;
}

// bee-date-input
.styled.bee-date-input .v-input__control .bee-date-inputs {
	> * {
		margin-right: 0 !important;
		margin-left: 0 !important;
	}
	* {
		text-align: center;
	}
	> *:nth-child(2) {
		flex: 2;
	}
	> *:nth-child(4) {
		flex: 1;
	}
	> *:nth-child(6) {
		flex: 1;
	}
}

// table
.with-sex tbody tr td:first-child {
	border-right: 5px solid rgb(121, 211, 255);
}
.with-sex tbody tr.female-row td:first-child,
.with-sex tbody tr.female-row + .v-data-table__expanded.v-data-table__expanded__content td:first-child {
	border-color: #ff91de;
}

// level input
.level-input {
	position: relative;
	.v-input__slider {
		position: absolute;
		top: -3px;
		right: 0;
		width: calc(100px + 1rem);
		opacity: 0;
		.v-slider__thumb::before {
			transform: scale(0) !important;
		}
	}
}

// tree as table
.styled-tree .v-treeview-node__children {
	border-top: 1px solid #ddd;
	border-bottom: 1px solid #ddd;
}
.styled-tree .v-treeview-node:nth-child(odd) {
	background: #f0f0f0;
}
.styled-tree .v-treeview-node:nth-child(even) {
	background: #ffffff;
}

// absent row in attendance
.is-absent-row {
	background-image: linear-gradient(
		60deg,
		#ffcdd2 25%,
		transparent 25%,
		transparent 50%,
		#ffcdd2 50%,
		#ffcdd2 75%,
		transparent 75%,
		transparent 100%
	) !important;
	background-size: 20px 100% !important;
	background-repeat: repeat !important;
	background: #ffcdd2 !important;
}
</style>
